import { Button, Card } from "@mantine/core";
import shadows from "@material-ui/core/styles/shadows";

export const ThemedButton = Button.withProps({
	bdrs: 'sm',
	color: "themed.8",
	px: 20,
})

export const LightThemedButton = Button.withProps({
	bdrs: 'sm',
	variant: "outline",
	color: "themed.8",
})


export const ThemedCard = Card.withProps({
	bg: "#F0FDFF",
	bdrs: 20,
	// style: {
	// 	boxShadow: "1px 2px 3px 1px rgba(0, 0, 0, 0.2)",
	// }
	shadow: "1px 2px 3px 1px rgba(0, 0, 0, 0.2)"
})